export default "__VITE_ASSET__CqKC5tfp__"